module.exports = __webpack_public_path__ + "assets/images/premium-features/labor-cost-e3df5a.png";